import { NavLink } from "react-router-dom";
import { ListChecks, NotebookPen } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export const TasksTabs = () => {
  const { canAccessTab } = useAuth();
  return <nav aria-label="Rubriques des tâches" className="flex border-b border-slate-200 mb-6 gap-5 min-w-0" data-testid="tasks-tabs">
  {[...(canAccessTab("tasks") ? [{ to: "/taches", label: "Tâches", Icon: ListChecks, test: "subtab-tasks-list" }] : []), { to: "/taches/recap", label: "Récap du jour", Icon: NotebookPen, test: "subtab-daily-recap" }].map(({ to, label, Icon, test }) =>
    <NavLink key={to} to={to} end className={({ isActive }) => `min-h-12 flex items-center gap-2 border-b-2 text-sm transition-colors ${isActive ? "border-[#26788A] text-[#26788A] font-semibold" : "border-transparent text-slate-500 hover:text-slate-800"}`} data-testid={test}>
      <Icon size={17} className="shrink-0" />{label}
    </NavLink>)}
</nav>;
};